import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { ModalFooter } from 'syf-component-library/ui/patterns/SlideInModalPortal';
export const FooterWrapper = styled.div `
  display: flex;
`;
export const Footer = styled(ModalFooter) `
  width: 100%;
  min-height: 0;
  padding: 10px;
  gap: 10px;
  & > button {
    margin-bottom: inherit;

    @media ${query.greaterThanMedium} {
      min-width: fit-content;
    }
  }
  @media ${query.lessThanMedium} {
    margin: 0 auto;
  }
`;
